export const STEPS = [
  { key: "idea", num: "01",
    label: { EN: "Idea", IT: "Idea" },
    q: { EN: "What is your idea?", IT: "Qual è la tua idea?" },
    ph: { EN: "Describe your idea freely, what it is, who it helps, why it matters to you.", IT: "Descrivi liberamente la tua idea, cos'è, chi aiuta, perché conta per te." } },
  { key: "problem", num: "02",
    label: { EN: "Problem", IT: "Problema" },
    q: { EN: "What problem does this solve?", IT: "Che problema risolve?" },
    ph: { EN: "The real pain, when it happens, and how people cope today.", IT: "Il vero problema, quando accade e come lo affrontano oggi." } },
  { key: "customer", num: "03",
    label: { EN: "Customer", IT: "Cliente" },
    q: { EN: "Who has this problem?", IT: "Chi ha questo problema?" },
    ph: { EN: "The specific person, their context, motivation and behavior.", IT: "La persona specifica, il suo contesto, motivazione e comportamento." } },
  { key: "market", num: "04",
    label: { EN: "Market", IT: "Mercato" },
    q: { EN: "Where does this idea live?", IT: "Dove vive questa idea?" },
    ph: { EN: "Category, segment and the initial opportunity you see.", IT: "Categoria, segmento e l'opportunità iniziale che vedi." } },
  { key: "competition", num: "05",
    label: { EN: "Competition", IT: "Concorrenza" },
    q: { EN: "Who or what already solves this?", IT: "Chi o cosa lo risolve già?" },
    ph: { EN: "Direct competitors, alternatives, and what people do instead.", IT: "Concorrenti diretti, alternative e cosa fanno le persone al loro posto." } },
  { key: "offer", num: "06",
    label: { EN: "Offer", IT: "Offerta" },
    q: { EN: "What exactly are you selling?", IT: "Cosa stai vendendo esattamente?" },
    ph: { EN: "The product or service, its value and how it's delivered.", IT: "Il prodotto o servizio, il suo valore e come viene erogato." } },
  { key: "price", num: "07",
    label: { EN: "Price", IT: "Prezzo" },
    q: { EN: "What could someone pay for this?", IT: "Quanto potrebbe pagare qualcuno?" },
    ph: { EN: "Your best guess at a price, and why.", IT: "La tua migliore ipotesi di prezzo, e perché." } },
  { key: "validation", num: "08",
    label: { EN: "Validation", IT: "Validazione" },
    q: { EN: "What would prove this is worth pursuing?", IT: "Cosa proverebbe che vale la pena perseguirla?" },
    ph: { EN: "What evidence would convince you it's real.", IT: "Quale evidenza ti convincerebbe che è reale." } },
  { key: "mvp", num: "09",
    label: { EN: "MVP", IT: "MVP" },
    q: { EN: "What is the smallest version you could build?", IT: "Qual è la versione più piccola che potresti costruire?" },
    ph: { EN: "The absolute minimum that delivers the core value.", IT: "Il minimo assoluto che offre il valore centrale." } },
  { key: "business_model", num: "10",
    label: { EN: "Business model", IT: "Modello" },
    q: { EN: "How could this make money?", IT: "Come potrebbe fare soldi?" },
    ph: { EN: "Revenue, costs, distribution, the basic economics.", IT: "Ricavi, costi, distribuzione, l'economia di base." } },
  { key: "risk", num: "11",
    label: { EN: "Risk", IT: "Rischio" },
    q: { EN: "What could kill this idea?", IT: "Cosa potrebbe uccidere questa idea?" },
    ph: { EN: "The most important risks and how you'd reduce them.", IT: "I rischi più importanti e come li ridurresti." } },
];

export const FREE_STAGES = 3;
